import initialState from './initial.state';
import * as types from '../actions/types.action';
import {stampSearchId} from '../helpers/data.helper';

export default function shoppingListLookupReducer(
  state = initialState.shoppingListLookup,
  action
) {
  switch (action.type) {
    case types.GET_LISTS_BY_ID_SUCCESS:
      // These results skip processedGQLSearchResults, so stamp the searchId here instead - without
      // it, adds from a shopping list cannot be traced back to the lookup that surfaced them.
      return action.shoppingListLookup
        ? Object.assign({}, action.shoppingListLookup, {
            results: stampSearchId(
              action.shoppingListLookup.results,
              action.shoppingListLookup.searchId
            ),
          })
        : [];
    case types.GET_LISTS_BY_ID_REQUESTED:
    case types.GET_LISTS_BY_ID_FAILED:
      return null;
    case types.GET_MORE_LISTS_BY_ID_SUCCESS:
      // Each page is its own lookup with its own searchId, so stamp the incoming page only and
      // leave the already-stamped earlier pages alone.
      return {
        page: action.shoppingListLookup.page,
        results: [
          ...state.results,
          ...stampSearchId(
            action.shoppingListLookup.results,
            action.shoppingListLookup.searchId
          ),
        ],
      };
    case types.REMOVE_FROM_SHOPPING_LIST_LOOKUP_SUCCESS:
      const newPage = Object.assign({}, state && state.page, {
        totalElements:
          state && state.page && state.page.totalElements
            ? state.page.totalElements - 1
            : 0,
      });
      const results =
        state &&
        state.results &&
        state.results.filter(item => item.itemId !== action.itemId);
      return {page: newPage, results};
    case types.RENAME_SHOPPING_LIST_SUCCESS:
      return Object.assign({}, state, {
        name: action.results && action.results.name,
      });
    case types.RESET_SHOPPING_LIST_SUCCESS:
      return null;
    default:
      return state;
  }
}
